import { Component, Input, ElementRef, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { SideNavbarService } from './side-navbar.service';
import { Globals } from '../shared/globals';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { TopNavbarService } from '../top-navbar/top-navbar.service';
import { TextService } from '../shared/text.service';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'side-navbar',
  templateUrl: './side-navbar.component.html',
  styleUrls: ['./side-navbar.component.css']
})
export class SideNavbarComponent implements OnInit {

  @Input('is-mobile') isMobile: any;
  navigationItems: any;
  navigationSubscription: any;
  header: any;
  logoLocation = environment.logo;
  showSearchField = environment.showSearchField;
  showTermSelection = environment.showTermSelection;
  currentPeriodStartYear = environment.currentPeriodStartYear;
  searchPeriod = environment.searchPeriod;
  searchParams = '';
  placeholder = '';
  errorMessage: any;
  @ViewChild('searchField') searchField!: ElementRef;
  firstSchoolYear = environment.firstSchoolYear;
  //curriculumPeriod = environment.curriculumPeriod; //pituus
  curriculumPeriods = environment.curriculumPeriods; //kaikki kaudet
  periodIndex = this.curriculumPeriods.length-1;
  //currentPeriodStartYear: number;
  selectedSchoolYear!: number;
  period!: string;
  frontPageRoute = environment.redirectRoute;
  links: any;
  //navigationSubscription!: any;
  curriculumPeriodSubscription: any;
  linkSubscription: any;


  //searchFormControl = new FormControl('', [Validators.required, Validators.email]);

  //matcher = new MyErrorStateMatcher();


//search : string ="";
 


  constructor(
    public globals: Globals,
    private route: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
    private sideNavbarService: SideNavbarService,
    private textService: TextService,
    //haetaan linkit tämän avulla
    private topNavbarService: TopNavbarService) 
  {
    this.curriculumPeriodSubscription = this.globals.curriculumPeriodChanged.subscribe( period => this.onCurriculumPeriodChange(period));
  }
  
  private onCurriculumPeriodChange(period: string): void {
    this.selectedSchoolYear = Number(period.split('-')[0]);
    this.globals.selectedCurriculumPeriod = period;
    this.period = period;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl(this.globals.getLocalizedValue(environment.frontPageRoute).split('?')[0] + '?period=' + period); 
    //window.location.href = this.globals.getLocalizedValue(environment.frontPageRoute).split('?')[0] + '?period=' + period;
  }
  

  ngOnInit(): void {
    this.getLinks();
    this.reset();
    this.getNavigationItems();

    this.textService.getText('header').subscribe(
      value => this.header = value,
      error => this.errorMessage = <any>error
    );

    this.textService.getText('search.input.placeholder').subscribe(
      value => this.placeholder = value,
      error => this.errorMessage = <any>error
    );

    this.route.queryParams.subscribe(params => {
      this.period = params['period'];  
      
      if(this.period) {
        this.selectedSchoolYear = Number(this.period.split('-')[0]);
        this.globals.selectedCurriculumPeriod = this.period;

        //asetetaan oikea indeksi, kun saavutaan url-osoitteen kautta 
        //console.log(this.curriculumPeriods.indexOf(this.period));
        this.periodIndex = this.curriculumPeriods.indexOf(this.period);
      }
    });


  }

  ngOnDestroy() {
    this.navigationSubscription.unsubscribe();
    this.curriculumPeriodSubscription.unsubscribe();
  }

  reset(): void {
    const now = new Date();
    //let currentSchoolYear = now.getMonth() >= 7 ? now.getFullYear() : now.getFullYear() - 1;
    //jos aloitusvuosi ja opintokauden pituus parillisia, täytyy nykyisen kauden alunkin olla
    /*if (this.firstSchoolYear % 2 === 0 && this.currentSchoolYear % 2 === 0) {
      this.currentPeriodStartYear = this.currentSchoolYear;
    } else {
      this.currentPeriodStartYear = this.currentSchoolYear-1;
    }*/
    
    if(!this.period) {
      this.selectedSchoolYear = this.currentPeriodStartYear;
      //this.period = this.selectedSchoolYear.toString() + '-' + (this.selectedSchoolYear + this.curriculumPeriod).toString();
      this.period = this.curriculumPeriods[0];
    }

  }

  increase(): void {
       this.periodIndex++;
       //this.globals.setSelectedSchoolYear(this.selectedSchoolYear + this.curriculumPeriod);
       this.globals.setSelectedSchoolYear(Number(this.curriculumPeriods[this.periodIndex].split('-')[0]));
       //this.globals.setSelectedCurriculumPeriod((this.selectedSchoolYear + this.curriculumPeriod) + '-' + (this.selectedSchoolYear + (2*this.curriculumPeriod)));
       this.globals.setSelectedCurriculumPeriod(this.curriculumPeriods[this.periodIndex]);

  }

  increase2(event: any): void {
    if (event.key === "Enter") {
      this.increase();
    }
  }

  decrease(): void {
    this.periodIndex--;
      //this.globals.setSelectedSchoolYear(this.selectedSchoolYear - this.curriculumPeriod);
      //this.globals.setSelectedCurriculumPeriod(this.selectedSchoolYear-this.curriculumPeriod + '-' + this.selectedSchoolYear);
      this.globals.setSelectedSchoolYear(Number(this.curriculumPeriods[this.periodIndex].split('-')[0]));
      this.globals.setSelectedCurriculumPeriod(this.curriculumPeriods[this.periodIndex]);
  }


  decrease2(event: any): void {
    if (event.key === "Enter") {
      this.decrease();
    }
  }

  setUrl(): void {
  
  this.globals.createLinkForCanonicalURL();

  }

  search() {

    if (this.searchParams.length > 3) {
      const landingUrl = '/' + this.globals.lang + '/haku/' + this.searchParams + (this.period ?  '?period=' + this.period : '');
      console.log(landingUrl);
      this.router.navigateByUrl(landingUrl);
      this.searchParams = '';
      //this.renderer.invokeElementMethod(
      //  this.searchField.nativeElement, 'blur', []);
      //this.renderer.selectRootElement("blur").scrollIntoView();
      this.closeMobileNav();
    }

  }


  getNavigationItems() {
    this.navigationSubscription = this.sideNavbarService.getNavigationItems().subscribe(
      navigationItems => this.navigationItems = navigationItems
    );
  }

  getLinks() {
    this.linkSubscription = this.topNavbarService.getLinks().subscribe(
      links => this.links = links
    );
  }

  changeLang(lang: any) {
    this.globals.setLang(lang);
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl(this.globals.getCurrentUrl(lang)); 
  }
  
  changeLang2(event: any, lang: any) {
    if (event.key === "Enter") {
      this.changeLang(lang);
    }
  }

  closeMobileNav(): void {
    console.log('suljettu');
    if (this.isMobile) {
      this.sideNavbarService.close(); // use however your service closes the nav
    }
  }


}
